import { useState } from 'react';
import type { ProviderCommonProps } from '../../../types/provider.types';
import type { ClusterDetailsContextType } from './types';
import { ClusterDetailsContext } from './context';

export const ClusterDetailsProvider = ({ children }: ProviderCommonProps) => {
  const [activeInstallationId, setActiveInstallationId] = useState<string>('');

  const setActiveInstallation = (id: string) => {
    setActiveInstallationId(id);
  };

  const value: ClusterDetailsContextType = {
    activeInstallationId,
    setActiveInstallation,
  };

  return <ClusterDetailsContext.Provider value={value}>{children}</ClusterDetailsContext.Provider>;
};
